import { Money } from "models/money";

export function getExcelData(compounds) {
  let result = [];
  compounds.forEach((element) => {
    const total =
      element.quarterSales1 + element.quarterSales2 + element.quarterSales3 + element.quarterSales4;
    result.push({
      Numero: element.id,
      "Componente Molecular": element.molecularCompoundName,
      "Primer Trimestre": Money(element.quarterSales1),
      "Segundo Trimestre": Money(element.quarterSales2),
      "Tercer Trimestre": Money(element.quarterSales3),
      "Cuarto Trimestre": Money(element.quarterSales4),
      "Total Ventas": Money(total),
    });
  });
  return result;
}
